<h1 mat-dialog-title>
  {{title | translate}}
</h1>
<div mat-dialog-content>
  <p [innerHtml]="message"></p>
  <app-button-set align="right" marginBottom="4px">
    <app-button [mat-dialog-close]="null" primary="true" [label]="buttonLabel" icon="check" [preventFocus]="true"></app-button>
  </app-button-set>
</div>